<template>

  <!-- Modal -->
  <transition name="modal-fade">
    <div class="info_modal" v-if="modal_active">
      <svg width="100%" height="100%" viewBox="0 0 1280 720">

        <!-- BACKGROUND -->
        <g>
          <rect id="screen_background" stroke="#FFFFFF" stroke-width="5" fill-opacity="0" fill="#7BADD6" x="60" y="60" width="1161"
            height="600" rx="10"></rect>
          <rect id="left_background" fill="#7BADD6" opacity="0.95" x="62" y="62" width="1157" height="596" rx="10"></rect>
        </g>
        <!--  -->

        <!-- QUESTION PROMPT SCREEN -->
        <transition name="modal-fade">
          <g v-show="selected_answer === ''">

            <transition name="modal-fade">
              <!-- first slide (instructions) -->
              <g v-show="quiz_question < 1">
                <!-- Instructions Content -->
                <g id="quiz_instructions_container" transform="translate(230.000000, 289.000000)">
                  <text font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" text-align="center" fill="#FFFFFF">
                    <tspan x="-50.64209" y="-50.2890625">Just as Aye struggled to interpret the situation between the couple in the library, it</tspan>
                    <tspan x="-50.64209" y="-14.2890625">can be hard to interpret and assess the health of a relationship right away. As a</tspan>
                    <tspan x="-50.64209" y="22.2890625">class, take a few minutes to read the following scenarios and decide if they depict</tspan>
                    <tspan x="-50.64209" y="58.2890625">a healthy relationship or if there are red flags that indicate an unhealthy or abusive</tspan>
                    <tspan x="-50.64209" y="94.2890625">situation.</tspan>
                    <tspan x="-50.64209" y="130.2890625"></tspan>
                    <tspan x="-50.64209" y="166.2890625"></tspan>
                    <tspan x="-50.64209" y="202.2890625"></tspan>
                  </text>
                </g>
                <!-- Start Quiz Button -->
                <g @click="toggle_quiz_question" id="proceed_button" transform="translate(500.000000, 480.000000)">
                  <rect fill="#FFFFFF" x="-10" y="80" width="250" height="44" rx="22"></rect>
                  <text font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" fill="#4A90E2">
                    <tspan x="15.4648438" y="108.7734375">Click To Test Your Instincts!</tspan>
                  </text>
                </g>
              </g>
            </transition>

            <!-- question text -->
            <g transform="translate(250.000000, 183.000000)">

              <!-- question 1 -->
              <text id="quiz_question" font-family="ScopeOne-Regular, Scope One" font-size="22" font-weight="normal" line-spacing="30" fill="#FFFFFF" v-show="quiz_question == 1">
                <tspan x="-65.64209" y="-15.2890625">Scott and Emily have been dating for the past three weeks. Since they started dating,</tspan>
                <tspan x="-65.64209" y="21.2890625">they’ve been having a ton of fun. They have spent every moment they can with one another,</tspan>
                <tspan x="-65.64209" y="57.2890625">and when they are not together, they text or video chat continually. Most nights they fall</tspan>
                <tspan x="-65.64209" y="93.2890625">asleep with video chat still on. Emily woke up a few days ago to see that their chat had</tspan>
                <tspan x="-65.64209" y="129.2890625">been going for 10 hours! What do you think? Is Emily and Scott’s relationship healthy, or are</tspan>
                <tspan x="-65.64209" y="165.2890625">there red flags?</tspan>
              </text>

              <!-- question 2 -->
              <text id="quiz_question" font-family="ScopeOne-Regular, Scope One" font-size="22" font-weight="normal" line-spacing="30" fill="#FFFFFF" v-show="quiz_question == 2">
                <tspan x="-105.64209" y="-50.2890625">Aretha and Anthony met each other while Anthony was dating someone else They only hung out a</tspan>
                <tspan x="-105.64209" y="-10.2890625">few times before he broke up with his girlfriend, but the reality is that he cheated. In the beginning</tspan>
                <tspan x="-105.64209" y="30.2890625"> of their relationship, everything seemed perfect. Then school and basketball season got crazy,</tspan>
                <tspan x="-105.64209" y="70.2890625">and Aretha has been feeling nervous lately. They are apart more than they’re together, and she</tspan>
                <tspan x="-105.64209" y="110.2890625">worries that he will meet someone new. Aretha has started asking Anthony to text and send photos</tspan>
                <tspan x="-105.64209" y="150.2890625">at certain times of day, so she can see where he is and who he is with. When he doesn’t respond</tspan>
                <tspan x="-105.64209" y="190.2890625">right away, Aretha texts and calls more. Is Aretha and Anthony’s relationship healthy, or are there</tspan>
                <tspan x="-105.64209" y="230.2890625">red flags?</tspan>
                <tspan x="-105.64209" y="270.2890625"></tspan>
                <tspan x="-105.64209" y="320.2890625"></tspan>
              </text>

              <!-- question 3 -->
              <text id="quiz_question" font-family="ScopeOne-Regular, Scope One" font-size="22" font-weight="normal" line-spacing="30" fill="#FFFFFF" v-show="quiz_question == 3">
                <tspan x="-105.64209" y="-50.2890625">Doug and Janelle have an intense relationship. When things are going well, they are going really</tspan>
                <tspan x="-105.64209" y="-10.2890625">well — and when things are going bad, they are really bad. Sometimes things even get physical.</tspan>
                <tspan x="-105.64209" y="30.2890625">Last week, Doug got so mad at Janelle that he posted nasty things about her on Facebook and an</tspan>
                <tspan x="-105.64209" y="70.2890625">explicit photo of her captioned “whore” on Snapchat. Janelle was embarrassed and had to</tspan>
                <tspan x="-105.64209" y="110.2890625">speak to the school resource officer because someone sent a screenshot of the photo to an</tspan>
                <tspan x="-105.64209" y="150.2890625">administrator. What do you think? Is Doug and Janelle’s relationship healthy, or are there red</tspan>
                <tspan x="-105.64209" y="190.2890625">flags?</tspan>
              </text>

              <!-- question 4 -->
              <text id="quiz_question" font-family="ScopeOne-Regular, Scope One" font-size="22" font-weight="normal" line-spacing="30" fill="#FFFFFF" v-show="quiz_question == 4">
                <tspan x="-105.64209" y="-50.2890625">Hannah and Rashid seem like an unlikely pair. When they met, Hannah wasn’t popular, while Rashid</tspan>
                <tspan x="-105.64209" y="-10.2890625">ruled the school. Hannah felt surprised and lucky that he was interested in her. At first, Rashid was</tspan>
                <tspan x="-105.64209" y="30.2890625">sweet, telling Hannah to be more confident because she was beautiful and smart. But after a while,</tspan>
                <tspan x="-105.64209" y="70.2890625">things began to change. When Hannah would make a mistake or do something Rashid found silly, he</tspan>
                <tspan x="-105.64209" y="110.2890625">would roll his eyes and say, “typical Hannah” or call her dumb. When he is especially annoyed with</tspan>
                <tspan x="-105.64209" y="150.2890625">her, he says she is lucky he dates her because no one else will put up with all the stupid things she</tspan>
                <tspan x="-105.64209" y="190.2890625">does. Is Hannah and Rashid’s relationship healthy, or are there red flags?</tspan>
              </text>

              <!-- question 5 -->
              <text id="quiz_question" font-family="ScopeOne-Regular, Scope One" font-size="22" font-weight="normal" line-spacing="30" fill="#FFFFFF" v-show="quiz_question == 5">
                <tspan x="-105.64209" y="-50.2890625">Matt and Michaela have been dating for 10 months. They started out as friends, and then one day</tspan>
                <tspan x="-105.64209" y="-10.2890625">Michaela confessed that she had a huge crush on Matt. They talked about what it would be like to</tspan>
                <tspan x="-105.64209" y="30.2890625">date, because they didn’t want to lose each other’s friendship. Now that they are together, they try</tspan>
                <tspan x="-105.64209" y="70.2890625">to go on dates with other couples but make sure they spend quality one-on-one time as well. At</tspan>
                <tspan x="-105.64209" y="110.2890625">times they drive each other crazy, but when those times happen they try their best to talk</tspan>
                <tspan x="-105.64209" y="150.2890625">through their issues. What do you think? Is Matt and Michaela’s relationship healthy, or are there</tspan>
                <tspan x="-105.64209" y="190.2890625">red flags?</tspan>
              </text>

            </g>
            <!--  -->

            <!-- buttons, shown on every question except initial screen -->
            <g transform="translate(251.000000, 203.000000)" v-show="quiz_question < 6 && quiz_question > 0">

              <!-- <g @click="toggle_answer_explanation" id="submit_button" :class="submit" transform="translate(685.000000, 275.000000)"> -->
              <g @click="toggle_answer_explanation" id="submit_button" transform="translate(685.000000, 275.000000)">
                <rect fill="#FFFFFF" x="-60" y="50" width="160" height="44" rx="22"></rect>
                <text font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" fill="#4A90E2">
                  <tspan x="-10.1111245" y="77.7734375">SUBMIT</tspan>
                </text>
              </g>

              <!-- Healthy button -->
              <g @click="toggle_healthy_answer_color" v-show="quiz_question < 6 && quiz_question > 0">
                <g class="answer" id="correct" transform="translate(0.000000, 290.000000)" fill="#FFFFFF">
                  <text id="healthy" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30">
                    <tspan x="-30" y="27.5">Healthy</tspan>
                  </text>
                  <g id="selected_answer" :class="healthy_selection_state">
                    <circle id="answer_selection" cx="-60" cy="20" r="10"></circle>
                    <circle id="health" class="answer_fill" fill="#599ED6" cx="-60" cy="20" r="7"></circle>
                  </g>
                </g>
              </g>

              <!-- Red flag button -->
              <g @click="toggle_red_flag_answer_color" v-show="quiz_question < 6 && quiz_question > 0">
                <g class="answer" id="wrong" transform="translate(0.000000, 110.000000)">
                  <text id="red_flag" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                    <tspan x="-30" y="280">Red Flag</tspan>
                  </text>
                  <g id="selected_answer" :class="red_flag_selection_state">
                    <circle id="answer_selection" fill="#FFFFFF" cx="-60" cy="270" r="10"></circle>
                    <circle id="red" class="answer_fill" fill="#599ED6" cx="-60" cy="270" r="7"></circle>
                  </g>
                </g>
              </g>
            </g>
            <!-- end buttons -->

          </g>
        </transition>
        <!-- END PROMPT SCREEN -->


        <!-- CORRECT/INCORRECT SCREEN -->
        <transition name="modal-fade">
          <g transform="translate(251.000000, 203.000000)" v-if="selected_answer !== ''">

            <!-- modal background color -->
            <rect transform="translate(-251.000000, -203.000000)" id="left_background" :fill="modalColor" x="62" y="62" width="1157"
              height="596" rx="10"></rect>

            <!-- modal text -->
            <g transform="translate(0.000000, 80.000000)">

              <!-- modal 1 text (correct for either) -->
              <text v-if="quiz_question === 1" id="healthy_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">You may be right. The beginning of relationships can be naturally exciting and</tspan>
                <tspan x="-75.64209" y="21.2890625">consuming emotionally. You like each other so much that you want to spend all your</tspan>
                <tspan x="-75.64209" y="57.2890625">time together. Spending a lot of time with one another and communicating constantly</tspan>
                <tspan x="-75.64209" y="93.2890625">using digital technology doesn’t mean the relationship is unhealthy or abusive. Just</tspan>
                <tspan x="-75.64209" y="129.2890625">make sure that you begin to find a balance between your new relationship and the</tspan>
                <tspan x="-75.64209" y="165.2890625">rest of your life.</tspan>
                <tspan x="-75.64209" y="201.2890625"></tspan>
              </text>

              <!-- modal 2 (red flag) -->

              <!-- modal 2 correct text -->
              <text v-if="quiz_question === 2 && red_flag_selection_state === 'active'" id="red_flag_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">You are correct. The dynamic that Aretha is setting up in their relationship is one of</tspan>
                <tspan x="-75.64209" y="21.2890625">power and control. Aretha’s constant check-ins and blow-ups make it impossible for</tspan>
                <tspan x="-75.64209" y="57.2890625">Anthony to keep her happy. When Aretha becomes unhappy, she becomes</tspan>
                <tspan x="-75.64209" y="93.2890625">emotionally and psychologically abusive to Anthony.</tspan>
              </text>

              <!-- modal 2 incorrect text -->
              <text v-else-if="quiz_question === 2" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">While at first you may think Aretha is only trying to show Anthony how much she</tspan>
                <tspan x="-75.64209" y="21.2890625">cares about him, in reality, Aretha is using modes of power and control over</tspan>
                <tspan x="-75.64209" y="57.2890625">Anthony. Anthony may be feeling like he is walking on eggshells to keep Aretha</tspan>
                <tspan x="-75.64209" y="93.2890625">happy. Aretha’s jealousy is impacting Anthony’s ability to maintain his normal life.</tspan>
              </text>

              <!-- modal 3 (red flag) -->

              <!-- modal 3 correct text -->
              <text v-if="quiz_question === 3 && red_flag_selection_state === 'active'" id="healthy_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">You are correct. Doug and Janelle’s relationship is full of red flags. Healthy relationships</tspan>
                <tspan x="-75.64209" y="21.2890625">do not feel like a rollercoaster. They of course have their ups and downs, but mutually</tspan>
                <tspan x="-75.64209" y="57.2890625">respectful partners know what to expect from one another. Healthy relationships are</tspan>
                <tspan x="-75.64209" y="93.2890625">also not physically abusive, and exploiting a partner on social media is NEVER okay.</tspan>
              </text>

              <!-- modal 3 incorrect text -->
              <text v-else-if="quiz_question === 3" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">You are incorrect. Doug and Janelle’s relationship is actually full of red flags. Healthy</tspan>
                <tspan x="-75.64209" y="21.2890625">relationships do not feel like a rollercoaster. They of course have their ups and downs,</tspan>
                <tspan x="-75.64209" y="57.2890625">but mutually respectful partners know what to expect from one another. Healthy</tspan>
                <tspan x="-75.64209" y="93.2890625">relationships are also not physically abusive, and exploiting a partner on social media</tspan>
                <tspan x="-75.64209" y="129.2890625">is NEVER okay.</tspan>
              </text>

              <!-- modal 4 (red flag) -->

              <!-- modal 4 correct text -->
              <text v-if="quiz_question === 4 && red_flag_selection_state === 'active'" id="healthy_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-75.64209" y="-15.2890625">You are correct. When someone constantly puts down their partner, it can cause their</tspan>
                <tspan x="-75.64209" y="21.2890625">partner’s self worth to drop drastically. A healthy relationship is focused on uplifting</tspan>
                <tspan x="-75.64209" y="57.2890625">a partner, not bringing them down. Many victims stay in an abusive relationship</tspan>
                <tspan x="-75.64209" y="93.2890625">longer because their abuser has convinced them that no one else would love them,</tspan>
                <tspan x="-75.64209" y="129.2890625">and they are the kind one for staying with them.</tspan>
              </text>

              <!-- modal 4 incorrect text -->
              <text v-else-if="quiz_question === 4" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-90.64209" y="-15.2890625">You are incorrect. When someone constantly puts down their partner it can cause their</tspan>
                <tspan x="-90.64209" y="21.2890625">partner’s self worth to drop drastically. A healthy relationship is focused on uplifting a</tspan>
                <tspan x="-90.64209" y="57.2890625">partner, not bringing them down. Many victims stay in an abusive relationship longer</tspan>
                <tspan x="-90.64209" y="93.2890625">because their abuser has convinced them that no one else would love them and they</tspan>
                <tspan x="-90.64209" y="129.2890625">are the kind one for staying with them.</tspan>
              </text>

              <!-- modal 5 (healthy) -->

              <!-- modal 5 correct text -->
              <text v-if="quiz_question === 5 && healthy_selection_state === 'active'" id="healthy_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-95.64209" y="-15.2890625">You are correct. Matt and Michaela seem to be enjoying each other and their relationship.</tspan>
                <tspan x="-95.64209" y="21.2890625">Sure, everything might not always be perfect, but by focusing on communication and</tspan>
                <tspan x="-95.64209" y="57.2890625">mutual respect, their relationship is on the right track. It might not last forever, but for</tspan>
                <tspan x="-95.64209" y="93.2890625">now it is a healthy relationship.</tspan>
              </text>

              <!-- modal 5 incorrect text -->
              <text v-else-if="quiz_question === 5" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
                <tspan x="-95.64209" y="-15.2890625">You are incorrect. Matt and Michaela seem to be enjoying each other and their relationship.</tspan>
                <tspan x="-95.64209" y="21.2890625">Sure, everything might not always be perfect but by focusing on communication and</tspan>
                <tspan x="-95.64209" y="57.2890625">mutual respect, their relationship is on the right track. Just because a couple fights doesn’t</tspan>
                <tspan x="-95.64209" y="93.2890625">mean the relationship is abusive. Matt and Michaela’s relationship might not last forever,</tspan>
                <tspan x="-95.64209" y="129.2890625">but for now it is a healthy relationship.</tspan>
              </text>

            </g>
            <!-- end modal text -->


            <!-- healthy/red flag indicator -->
            <text v-if="healthy_selection_state === 'active'" id="healthy_flag_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
              <tspan x="340.994629" y="17.5">Healthy</tspan>
            </text>

            <text v-if="red_flag_selection_state === 'active'" id="red_flag_explanation" font-family="ScopeOne-Regular, Scope One" font-size="24" font-weight="normal" line-spacing="30" fill="#FFFFFF">
              <tspan x="340.994629" y="17.5">Red Flag</tspan>
            </text>

            <!-- <g transform="translate(0.000000, 80.000000)">
              <circle id="Oval" fill="#FFFFFF" cx="315.994629" cy="-69.7890625" r="10"></circle>
              <circle id="Oval" :fill="modalColor" cx="315.994629" cy="-69.7890625" r="7"></circle>
            </g> -->

            <text font-family="ScopeOne-Regular, Scope One" font-size="50" font-weight="normal" line-spacing="50" fill="#FFFFFF">
              <!-- todo: make conditional -->
              <tspan v-if="!isCorrect" x="238.994629" y="-25.2890625">NOT QUITE.</tspan>

              <tspan v-if="isCorrect" x="268.994629" y="-25.2890625">CORRECT!</tspan>

            </text>

            <g @click="toggle_quiz_question" id="proceed_button" transform="translate(611.000000, 310.000000)">
              <rect fill="#FFFFFF" x="0" y="40" width="155" height="44" rx="22"></rect>
              <text font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" fill="#707070">
                <tspan x="42.2361245" y="67.7734375">PROCEED</tspan>
              </text>
            </g>

          </g>
        </transition>
        <!-- END CORRECT/INCORRECT SCREEN -->
        <transition name="modal-fade">
              <!-- last slide (class instructions) -->
              <g v-show="quiz_question > 5">
                <!-- Class Instructions Content -->
                <g id="class_instructions_container" transform="translate(230.000000, 300.000000)">
                  <text font-family="ScopeOne-Regular, Scope One" font-size="26" font-weight="normal" text-align="center" line-spacing="20" fill="#FFFFFF">
                    <tspan x="-50.64209" y="-50.2890625">In order to Take a Stand FOR Healthy Relationships, it is important to be able</tspan>
                    <tspan x="-50.64209" y="-14.2890625">to identify components of an unhealthy or abusive relationship. Your teacher</tspan>
                    <tspan x="-50.64209" y="22.2890625">has a few lessons to practice this skill so that you too can Take a Stand FOR</tspan>
                    <tspan x="-50.64209" y="58.2890625">Healthy Relationships.</tspan>
                  </text>
                </g>
                <!-- End Quiz Button -->
                <g @click="closeModal" id="proceed_button" transform="translate(500.000000, 480.000000)">
                  <rect fill="#FFFFFF" x="50" y="80" width="155" height="44" rx="22"></rect>
                  <text font-family="ScopeOne-Regular, Scope One" font-size="16" font-weight="normal" line-spacing="16" fill="#4A90E2">
                    <tspan x="90.4648438" y="108.7734375">PROCEED</tspan>
                  </text>
                </g>
              </g>
            </transition>

      </svg>
    </div>
  </transition>
</template>

<script>
  import anime from 'animejs';


  export default {
    props: ['modal_active'],
    data() {
      return {

      lab_ready_state: {
        lab_doors_active: false,
        lab_doors_visible: true
      },

        // MODAL
        // modal_active: true,
        modal_ready: false,
        // determines text on modal
        quiz_question: 0,
        // determines if modal has question or explanation
        content_type: '',

        // turns button blue when active
        healthy_selection_state: '',
        red_flag_selection_state: '',
        answer_selection: '',
        active_question: false,

        // explains correct or incorrect reasoning
        selected_answer: '',
        modal_type: '',

      }
    },
    methods: {
      ////////

      toggle_answer_explanation() {
        if (this.healthy_selection_state == 'active') {
          this.selected_answer = 'correct';
        } else if (this.red_flag_selection_state == 'active') {
          this.selected_answer = 'wrong';
        }

        this.active_question = false;
        this.answer_selection_state = 'active';
        console.log('quiz');

        anime({
          targets: '#answer_selection .selected_answer',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      // Toggles to next question
      toggle_quiz_question() {

        // DEBUG TAKE OUT LATER.
        this.active_question = true
        //

        this.answer_selection_state = '';
        this.selected_answer = '';
        this.healthy_selection_state = ''
        this.red_flag_selection_state = ''

        // if (this.active_question) {
        if (this.quiz_question < 6) { // stop at 5
          this.quiz_question += 1
        } else {
          this.closeModal()
        }
        // }

        console.log('ask question');
        this.content_type = 'question';

        // proceed to next question button
        anime({
          targets: '#proceed_button .quiz_content_type',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });

        console.log('question ' + this.quiz_question);
      },

      // Renders explanation of answer
      toggle_btwn_question_and_explanation(string) {
        this.active_question = true;
        this.content_type = string;
        console.log('ask question');

        // Renders answer button
        anime({
          targets: '#submit_button .quiz_content_type',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
        console.log(this.content_type)
      },

      selectQuizAnswer(string) {
        this.answer_explanation = string;
        this.active_question = false;
        console.log('answer explained');

        anime({
          targets: '#answer_selection .selected_answer',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      toggle_healthy_answer_color() {
        this.healthy_selection_state = 'active';
        this.red_flag_selection_state = '';
        console.log('healthy selected answer');

        anime({
          targets: '#selected_answer .answer_fill',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      toggle_red_flag_answer_color() {
        this.red_flag_selection_state = 'active';
        this.healthy_selection_state = '';
        console.log('red flag selected answer');

        anime({
          targets: '#selected_answer .answer_fill',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
      },

      toggle_modal() {
        if (this.modal_active) {
          this.modal_active = false;
          this.modal_ready = false;
        } else {
          this.modal_active = true;
          this.modal_ready = true;
        }
      },

      closeModal() {
        this.modal_active = false;
        this.modal_ready = false;

        // return this.modal_active = this.modal_ready;
        //
        anime({
          targets: '#submit_button',
          strokeDashoffset: [36, anime.setDashoffset],
          easing: 'linear'
        });
        this.$emit('moduleend');
      },
    },
    computed: { // all correct combinations
      // return this.modal_active = this.modal_ready;
    // },
      isCorrect() {
        let quiz_question = this.quiz_question
        let red_flag_selection_state = this.red_flag_selection_state
        let healthy_selection_state = this.healthy_selection_state
        return quiz_question === 1 ||
          quiz_question === 2 && red_flag_selection_state === 'active' ||
          quiz_question === 3 && red_flag_selection_state === 'active' ||
          quiz_question === 4 && red_flag_selection_state === 'active' ||
          quiz_question === 5 && healthy_selection_state === 'active'
      },
      modalColor() {
        return this.isCorrect ? '#BFE298' : '#FACE86'
      }
    }
  }

</script>

<style scoped lang="scss">
  @import '../../assets/scss/variables';
  @import '../../assets/scss/mixins'; // #FACE86 // incorrect fill
  // #BFE298 // correct fill
  .info_modal {
    @include full-center(absolute);

    #quiz_button,
    #proceed_button,
    #submit_button {
      cursor: pointer;
    }

    .selected_answer {
      cursor: pointer;
    }

    #selected_answer {
      &.active {
        .answer_fill {
          opacity: 1;
          transition: opacity 200ms;
        }
      }

      .answer_fill {
        cursor: pointer;
        opacity: 0;
        transition: opacity 200ms;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// quiz.vue?6691e323